import { HighLowCurrentSectionDataC11 } from './Data/C11/C11.data';

export const selectHighLowCurrentSectionData = (selectedTag, formName, formData) => {
    let filterViewData = { rows: [] };
    if (['C1-1', 'P7-7', 'P7-11', 'P7-1', 'P7-2', 'P7-3', 'P7-5', 'P7-35', 'P7-12', 'S8-1', 'S8-2'].includes(formName)) {
        filterViewData = HighLowCurrentSectionDataC11(selectedTag, formName, formData);
    }
    return filterViewData;
};
